import React from "react";
import "./Reviews.css";
import VasilisReviewImage from"../../assets/RealEnglishImages/VasilisReviewImage.jpg"
const reviews = [
  {
    id: 1,
    name: "Βασίλης Μ",
    rating: 5,
    text: "Η εμπειρία μου στο Real English Academy ήταν πραγματικά εξαιρετική! Η Μαρία με βοήθησε να βελτιώσω τις γλωσσικές μου δεξιότητες με έναν τρόπο διαδραστικό και ευχάριστο. Με τις καινοτόμες μεθόδους διδασκαλίας της, η εκμάθηση των Αγγλικών έγινε μια απολαυστική εμπειρία γεμάτη αυτοπεποίθηση και δημιουργικότητα. Τη συνιστώ ανεπιφύλακτα!",
    image: VasilisReviewImage,
  },
  {
    id: 2,
    name: "Αλέξανδρος Σ",
    rating: 5,
    text: "Συγχαρητήρια για τον Χρήστο!! Είμαστε σε ένα camping και ο Χρήστος μιλάει με ένα κοριτσάκι αγγλικά!!! Έπαθα την πλάκα μου!!!",
    image: "https://cdn-icons-png.flaticon.com/512/847/847970.png",
  },
  {
    id: 3,
    name: "Βερόνικα Ρ.",
    rating: 5,
    text: "Όταν το πάθος για την διδασκαλία των αγγλικών συναντά την αληθινή αγάπη για τα παιδιά το αποτέλεσμα είναι μοναδικό. Είμαστε ευγνώμονες για την πολύτιμη μάθηση και από καρδιάς ευχαριστούμε για όλα ❤️",
    image: "https://cdn-icons-png.flaticon.com/512/847/847969.png",
  },
];

const RatingStars = ({ rating }) => {
  return (
    <div className="stars">
      {[...Array(5)].map((_, index) => (
        <span key={index} className={index < rating ? "star filled" : "star"}>
          &#9733;
        </span>
      ))}
    </div>
  );
};

const Reviews = () => {
    return (
        <React.Fragment>
          <section className="section reviews-section position-relative " id="Reviews">
          <h2 className="reviews-title text-center py-5"> Hear From Our Happy Students! </h2>
            <div className="rating-summary">
          
            <div className="rating-star">⭐ 5</div>
            <p>Average Rating<br/>Based on 3 ratings</p>
            <div className="rating-bars">
              {[
                { stars: 5, value: 3 },
                { stars: 4, value: 0 },
                { stars: 3, value: 0 },
                { stars: 2, value: 0 },
                { stars: 1, value: 0 },
              ].map(({ stars, value }) => (
                <div key={stars} className="rating-row">
                  <span>{stars} star</span>
                  <div className="bar">
                    <div className="fill" style={{ width: `${(value / 3) * 100}%` }}></div>
                  </div>
                </div>
              ))}
            </div>
            </div>
            <div className="reviews-container">
              {reviews.map((review) => (
                <div key={review.id} className="review-card">
                  <img src={review.image} alt={review.name} className="review-avatar" />
                  <div className="review-content">
                    <h3 className="review-name">{review.name}</h3>
                    <RatingStars rating={review.rating} />
                    <p className="review-text">{review.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </React.Fragment>
    );
};

export default Reviews;